// file: `app/components/cms/CmsTransformer.tsx`
import React from 'react';

import CmsAnchor from '~/components/cms/CmsAnchor';
import CmsButton from '~/components/cms/CmsButton';
import CmsColumns from '~/components/cms/CmsColumns';
import CmsDownloads from '~/components/cms/CmsDownloads';
import CmsHtml from '~/components/cms/CmsHtml';
import CmsImage from '~/components/cms/CmsImage';
import CmsImageCollection from '~/components/cms/CmsImageCollection';
import CmsQuote from '~/components/cms/CmsQuote';
import CmsRow from '~/components/cms/CmsRow';
import CmsSeparator from '~/components/cms/CmsSeparator';
import CmsTable from '~/components/cms/CmsTable';
import CmsText from '~/components/cms/CmsText';
import CmsTitle from '~/components/cms/CmsTitle';
import CmsTwoColumns from '~/components/cms/CmsTwoColumns';
import CmsVideo from '~/components/cms/CmsVideo';
import CmsYoutube from '~/components/cms/CmsYoutube';
import { CmsItem } from '~/types/Cms';

interface CmsTransformerProps {
  item: CmsItem;
  className?: string;
  /** Render the HTML block as-is, skipping the wpautop paragraph wrapping. */
  disableAutop?: boolean;
}

const CmsTransformer = ({ item, className = 'my-4', disableAutop = false }: CmsTransformerProps) => {
  const renderContent = (): JSX.Element | null => {
    switch (item.code) {
      case 'monsieurbiz.anchor':
        return <CmsAnchor data={item.data} />;
      case 'monsieurbiz.button':
        return <CmsButton data={item.data} />;
      case 'monsieurbiz.title':
        return <CmsTitle data={item.data} />;
      case 'monsieurbiz.html':
        return <CmsHtml data={item.data} disableAutop={disableAutop} />;
      case 'monsieurbiz.image':
        return <CmsImage data={item.data} />;
      case 'monsieurbiz.image_collection':
        return <CmsImageCollection data={item.data} />;
      case 'monsieurbiz.quote':
        return <CmsQuote data={item.data} />;
      case 'monsieurbiz.separator':
        return <CmsSeparator data={item.data} />;
      case 'monsieurbiz.column':
        return <CmsColumns data={item.data} />;
      case 'monsieurbiz.row':
        return <CmsRow data={item.data} />;
      case 'monsieurbiz.text':
        return <CmsText data={item.data} />;
      case 'monsieurbiz.two_columns':
        return <CmsTwoColumns data={item.data} />;
      case 'monsieurbiz.video':
        return <CmsVideo data={item.data} />;
      case 'monsieurbiz.youtube':
        return <CmsYoutube data={item.data} />;
      case 'app.downloads_block':
        return <CmsDownloads data={item.data} />;
      case 'app.table':
        return <CmsTable data={item.data} />;
      default:
        return null;
    }
  };

  const content = renderContent();
  if (!content) return null;

  return <div className={className}>{content}</div>;
};

export default CmsTransformer;
